module.exports = __webpack_public_path__ + "static/media/mobile834.c335011c.png";